export const enumStatutAbonnement = {
    INCONNU: 0,
    EN_COURS: 1,
    ANNULE: 2
}